import React from 'react';
type TimelineItem = {
  period: string;
  quote: string;
};
type TestimonialCardProps = {
  name: string;
  title: string;
  image: string;
  story: string;
  timeline: TimelineItem[];
};
export function TestimonialCard({
  name,
  title,
  image,
  story,
  timeline
}: TestimonialCardProps) {
  return <div className="bg-gray-50 rounded-lg p-4 sm:p-6" data-id="element-253">
      <div className="flex items-center mb-4" data-id="element-254">
        <img src={image} alt={name} className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-255" />
        <div data-id="element-256">
          <h3 className="font-bold" data-id="element-257">{name}</h3>
          <p className="text-gray-600" data-id="element-258">{title}</p>
        </div>
      </div>
      <div className="mb-6 whitespace-pre-line" data-id="element-259">{story}</div>
      <div className="space-y-4" data-id="element-260">
        {timeline.map((item, index) => <div key={index} className="border-l-2 border-blue-500 pl-4" data-id="element-261">
            <h4 className="font-medium text-blue-700" data-id="element-262">{item.period}</h4>
            <p className="italic" data-id="element-263">"{item.quote}"</p>
          </div>)}
      </div>
    </div>;
}